<template>
  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix">
      <span class="headerTxt">已购资产</span>
      <div class="searchWrap">
        <el-input @change="iptChange" :clearable="true" style="width: 200px;" v-model="acqAssVal" placeholder="请输入标题搜索"
          @keyup.enter.native="btnSearch" @clear="draftsResetBtn"></el-input>
        <el-button class="btn" @click="btnSearch">查 询</el-button>
        <el-button class="resetBtn" @click="draftsResetBtn">重 置</el-button>
      </div>
    </div>
    <el-table :data="tableList" v-loading="tableLoading" style="width: 100%; min-height: 300px"
      :header-cell-style="{ background: '#F5F5F5', textAlign: 'center' }">
      <el-table-column prop="assetsId" label="编号" align="center"></el-table-column>

      <el-table-column label="预览" width="150" align="center">
        <template slot-scope="scope">
          <img width="150px" :src="linkAllImgUrl(scope.row.imageUrl)" alt />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center"></el-table-column>

      <el-table-column prop="copyright" label="版权" align="center">
        <template slot-scope="scope">{{ rightText(scope.row.copyright) }}</template>
      </el-table-column>

      <el-table-column prop="usePrice" label="花费" align="center" width="110"></el-table-column>
      <el-table-column prop="createdTime" label="购买时间" align="center" width="155"></el-table-column>

      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleLook(scope.row)">查看</el-button>
          <el-button size="mini" type="success" @click="showDownLoad(scope.row)">下载</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-box">
      <el-pagination background layout="prev, pager, next" :current-page="pageObj.pageNum" :total="total"
        :page-size="pageObj.pageSize" @current-change="pageChange"></el-pagination>
    </div>

    <el-dialog title="下载资产" :visible.sync="downModal" width="600px">
      <template v-if="detailObj.fileList && detailObj.fileList.length">
        <ul style="padding: 0;list-style: none;">
          <li v-for="(item, index) in detailObj.fileList" :key="item.fileId">
            <span>{{ item.name }}</span>
            <el-link :disabled="!!item.disabled" type="primary" @click="downLoadFun(item.fileId, item.name, index)"
              style="margin-left: 10px;">下载</el-link>
          </li>
        </ul>
      </template>

      <template v-if="detailObj.netDisk">
        <el-form :model="detailObj" ref="netDiskForm" label-width="80px">
          <el-form-item label="网盘链接" prop="netDisk">
            <span>{{ detailObj.netDisk }}</span>
          </el-form-item>
          <el-form-item label="提取码" prop="netDiskCode">
            <span>{{ detailObj.netDiskCode }}</span>
          </el-form-item>
        </el-form>
      </template>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downModal = false">确 定</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { myDownloadList, resourceDetailApi, downLoadApi, downLoadUrlApi } from "@/api/extra";
import { mapListApi } from "@/api/resource";
import commonMixin from "@/mixins/commonMixin";
import { Message } from "element-ui";
export default {
  mixins: [commonMixin],
  data () {
    return {
      pageObj: {
        pageSize: 10,
        pageNum: 1,
      },
      total: 0,
      tableList: [],
      tableLoading: false,
      detailObj: {},
      formInline: {
        user: "",
        region: "",
      },
      downModal: false,
      list: null,
      listLoading: true,
      copyrightList: [],
      acqAssVal: '', // 搜索框val
      pageIndex: 1
    };
  },
  created () {
    this.getCopyrightList()
    this.fetchData()

  },
  methods: {
    /**
     * @ 改变页码
     */
    pageChange (pageIndex) {
      this.pageIndex = pageIndex // 获取页码
      this.pageObj = Object.assign({}, this.pageObj, { pageNum: pageIndex });
      let params = {
        ...this.pageObj,
        title: this.acqAssVal
      }
      myDownloadList(params).then((res) => {
        this.tableList = res.data.list;
      });
    },
    downLoadFun (fileId, papersName = '', index) {
      let isBowerCanDown = true;
      if (papersName) {  // 如果存在资源文件
        let lastIndex = papersName.lastIndexOf('.'); // 下载了几次

        if (lastIndex > -1) {
          const suffix = papersName.slice(lastIndex);// .zip后缀

          var reg = /\.(png|jpg|gif|jpeg|webp)$/i;
          if (reg.test(suffix)) {
            isBowerCanDown = false; // 如果文件资源后缀 是以上正则中的 则用户不能下载
          }
        }
      }

      // 如果用户可以下载
      if (isBowerCanDown) {
        this.detailObj.fileList[index].disabled = 1
        downLoadUrlApi({ fileId }).then(res => {
          if (res.code == 200) {
            const url = res.data; // 文件下载地址
            const link = document.createElement('a'); // 创建一个a标签
            link.style.display = 'none' // a标签隐藏
            link.href = url; // 将后端的文件下载地址赋值给a标签的href上
            link.setAttribute('download', papersName); // 然后给a标签设置download属性, 值为文件名
            document.body.appendChild(link) // 将a标签放进body中
            link.click() // 给a标签绑定点击事件
            document.body.removeChild(link)
            setTimeout(() => {
              this.detailObj.fileList[index].disabled = 0
            }, 3000)
          } else {

            this.$message.error(res.message);
          }
        });
      } else {
        this.detailObj.fileList[index].disabled = 1
        downLoadApi({ fileId }).then(res => {

          if (!res) return;
          try {
            //如果JSON.parse(enc.decode(new Uint8Array(res.data)))不报错，说明后台返回的是json对象，则弹框提示
            //如果JSON.parse(enc.decode(new Uint8Array(res.data)))报错，说明返回的是文件流，进入catch，下载文件
            let enc = new TextDecoder('utf-8')
            res = JSON.parse(enc.decode(new Uint8Array(res.data))) //转化成json对象

            if (res.code == 200) {
              Message.error(res?.message);
            } else {
              Message.error(res?.message);
            }
          } catch (e) {
            // console.log(e)
            // 假设 data 是返回来的二进制数据
            const data = res.data;
            // content-disposition
            let fileName = res.headers['content-disposition'];
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');

            if (fileName) {
              fileName = fileName.replace('attachment;filename=', '');
            }

            link.style.display = 'none'
            link.href = url;
            link.setAttribute('download', papersName || fileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            setTimeout(() => {
              this.detailObj.fileList[index].disabled = 0
            }, 3000)
          }
        });
      }
    },
    getDetail (id) {
      resourceDetailApi(id).then(res => {
        if (res.code === 200) {
          res.data.fileList.forEach(item => item.disabled = false)
          this.detailObj = res.data
        }
      })
    },
    showDownLoad (row) {
      this.downModal = true;
      this.getDetail(row.assetsId)
    },
    onSubmit () {
      console.log("submit!");
    },
    rightText (right) {
      for (let i = 0; i < this.copyrightList.length; i++) {
        if (right === this.copyrightList[i].id) {
          return this.copyrightList[i].name
        }
      }
      return ''
    },
    goDetail (row) {
      this.$router.push(`/resource/list/detail/${row.id}`);
    },
    handleDelete (row) {
      alert("删除");
    },
    handleEdit (row) {
      alert("删除");
    },
    /* 获取版权类型列表 */
    getCopyrightList () {
      mapListApi({ type: 6 }).then(res => {
        if (res.code === 200) {
          this.copyrightList = res.data;
        }
      })
    },
    fetchData () {
      this.tableLoading = true;
      let params = {
        ...this.pageObj,
        title: this.acqAssVal
      }
      myDownloadList(params).then((res) => {

        this.tableList = res.data.list

        this.total = res.data.total
        this.tableLoading = false;

      });
    },
    /**
     * 
     * @desc 点击查看
     */
    handleLook (row) {
      //this.$router.push(`/detail?id=${row.assetsId}`)
      this.$router.push({
        path: '/detail',
        query: {
          id: row.assetsId,
          path: 'myDownload'
        }
      })
    },
    /**
     * 仅在输入框失去焦点或用户按下回车时触发
     */
    iptChange (val) {
      this.acqAssVal = val;
      this.pageIndex = 1 // 获取页码
      this.pageObj = Object.assign({}, this.pageObj, { pageNum: this.pageIndex });
      let params = {
        ...this.pageObj,
        title: this.acqAssVal
      }
      myDownloadList(params).then((res) => {
        this.tableList = res.data.list;
      });
    },
    /**
     * @ 点击查询
     */
    btnSearch () {
      let params = {
        ...this.pageObj,
        title: this.acqAssVal
      }
      myDownloadList(params).then((res) => {
        this.tableList = res.data.list
        this.total = res.data.total
      });

    },
    /**
    * @ 点击重置
    */
    draftsResetBtn () {
      this.acqAssVal = '';
      this.$set(this.pageObj, 'pageNum', 1)
      this.btnSearch();

    }

  },
};
</script>
<style lang="less" scoped>
.box-card {
  margin-bottom: 10px;
  border: none;
}

.pagination-box {
  padding: 30px 20px;
  text-align: right;
}

.t {
  text-align: center;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1c6f6e;
  color: #FFF !important;
}

/deep/.el-pager li:hover {
  color: #1c6f6e !important;
}

.headerTxt {
  color: #1c6f6e;
  font-size: 16px;
  font-weight: bold;
}

.searchWrap {
  display: inline-block;
  margin-left: 400px;

  .btn {
    margin-left: 10px;
    background-color: #fff;
    color: #1c6f6e;
    font-size: 15px;

    &:hover {
      background-color: #1c6f6e;
      color: #fff;
    }
  }

  .resetBtn {
    margin-left: 10px;
    background-color: #fff;
    color: #073a39;
    font-size: 15px;

    &:hover {
      background-color: #073a39;
      color: #fff;
    }
  }

}

/deep/.el-button {
  border: 1px solid #DCDFE6;
}

/deep/.el-input__inner:focus {
  border: 1px solid #1c6f6e;
}


/deep/.el-input--suffix .el-input__inner {
  padding-right: 0;
}

/deep/.el-button--primary {
  background-color: rgb(37, 124, 216) !important;
  border: none;
  border-radius: 5px;
}

/deep/.el-button--success {
  border: none;
  border-radius: 5px;
}
</style>
